import { render, staticRenderFns } from "./UserManagementNavigation.vue?vue&type=template&id=1fd1d021&scoped=true"
import script from "./UserManagementNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserManagementNavigation.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UserManagementNavigation.vue?vue&type=style&index=0&id=1fd1d021&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd1d021",
  null
  
)

export default component.exports